// #region Dependencias
import styled, { keyframes } from 'styled-components'
import { colors } from 'components/Library/theme'
import { useEffect } from 'react'
// #endregion

// #region Estilos
const LoaderAnimation = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`

const StyledLoaderLine = styled.div`
  transform-origin: 40px 40px;
  animation: ${LoaderAnimation} 1.2s linear infinite;
  -webkit-animation: ${LoaderAnimation} 1.2s linear infinite;

  &:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: ${document.documentElement.style.getPropertyValue('--color-primario') ||
    colors.primary};
  }

  &:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }

  &:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }

  &:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }

  &:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }

  &:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }

  &:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }

  &:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }

  &:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }

  &:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }

  &:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }

  &:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }

  &:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
`

const StyledLoader = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.25);
  cursor: wait;
  display: flex;
  justify-content: center;
  margin: 0 0 0 -5rem;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  user-select: none;
  z-index: 10000;
`
// #endregion

/**
 * Componente que renderiza un efecto de carga o Loader.
 * @class
 * @example <Loader />
 */
const Loader = ({ cargando }) => {
  /**
   * Hook useEffect que actualiza el estilo de la página para mostrar u ocultar
   * la barra de desplazamiento dependiendo si el loader se está mostrando o no.
   */
  useEffect(() => {
    if (cargando) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'visible'
    }
  }, [cargando])

  if (cargando) {
    return (
      <StyledLoader>
        {[...Array(12)].map((_, i) => (
          <StyledLoaderLine key={i} />
        ))}
      </StyledLoader>
    )
  }
}

export default Loader
